export default __webpack_public_path__ + "static/media/pgmico(30).f11416ad.png";